export default "__VITE_ASSET__BWlzSydm__"